import url from 'tool/url.js'

let actions = {
    _storeResponseData: (status, responseBody)=>{
		return {
                    type: 'API_DATA__STORE_RESPONSE', // Any valid https status code
                    payload: {status: status, value: responseBody, error: null}
                }
    },
    _error: (error)=>{
		return {
                    type: 'API_DATA__ERROR',
                    payload: {status: null, value: null, error: error}
                }
    },
    _isFetching: ()=>{
        return {
            type: 'API_DATA__FETCHING',
            payload: {status: 'fetching', value: null, error: null}
        }
    },
    fetchApiData: (name)=>{
        return (dispatch)=>{
            dispatch(actions._isFetching())
            
            const settings = {
                method: 'GET',
                credentials: process.env.NODE_ENV === 'production' ? "same-origin" : "include"
            }

            fetch(url(`/doc/${name}`), settings)
            .then(res=>{
                if(res.status === 200){
                    try {
                        res.json().then(resBody=>{ dispatch(actions._storeResponseData(200, resBody)) })
                    } catch (error) {
                        dispatch(actions._error(error))
                    }
                }
                else {
                    dispatch(actions._storeResponseData(res.status, null))
                }
            })
            .catch(error=>{
                dispatch(actions._error(error))
            })
        }
    }
}

export default actions